import { IDocument } from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

const useBusinessEntityDocuments = ({
  businessEntityId,
}: {
  businessEntityId: number;
}) => {
  const {
    data,
    error,
    mutate,
  }: {
    data?: { documents: IDocument[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    businessEntityId ? `business-entities/${businessEntityId}/documents` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
};

export { useBusinessEntityDocuments };
